import React from 'react'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import Button from "@mui/material/Button";

const SessionNoteTabItem = ({id, name, date, time, onView}) => {
    return (
        <div 
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "16px 20px",
                backgroundColor: "#FFFFFF",
                border: "1px solid #E5E7EB",
                borderRadius: "8px",
                marginBottom: "8px",
                fontFamily: "Inter"
            }}
        >
            <div style={{ flex: 1 }}>
                <h6 
                    style={{
                        color: "#1F2937",
                        fontSize: "14px",
                        fontWeight: 500,
                        margin: 0,
                        marginBottom: "4px",
                        fontFamily: "Inter"
                    }}
                >
                    {name}
                </h6>
            </div>
            
            <div 
                style={{
                    color: "#6B7280",
                    fontSize: "13px",
                    fontWeight: 400,
                    fontFamily: "Inter",
                    minWidth: "120px",
                    textAlign: "center"
                }}
            >
                {date}
            </div>

            <div style={{ minWidth: "80px", textAlign: "right" }}>
                <Button 
                    onClick={() => onView(id)}
                    size="small"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        textTransform: 'none',
                        color: '#414141',
                        backgroundColor: '#fafafa',
                        padding: '6px 12px',
                        borderRadius: '50px',
                        fontSize: '13px',
                        fontWeight: 500,
                        margin: 0,
                        minWidth: 'auto',
                        fontFamily: "Inter"
                    }}
                >
                    <VisibilityOutlinedIcon fontSize="small" />
                    <span>View</span>
                </Button>
            </div>
        </div>
    )
}

export default SessionNoteTabItem